import { defineComponent as _defineComponent } from 'vue'
import {computed, ref, unref, watch} from 'vue';
import {TopUpRotation, WebChargeStatus} from "@/Enums";
import {useI18n} from "@/composables/useI18n";
import {debounce, isEmpty} from "@/scripts/Common/HelperFunctions";
import DateInput from "@/components/base/DateInput.vue";
import {isWholeNumber} from "@/scripts/Common/validators/defaultValidator";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFilterConfiguredWebcharges',
  emits: [
  'onHandleSearchFilterChange',
],
  setup(__props, { expose, emit: emits }) {

const {
  t,
} = useI18n();



const selectedRotation = ref<TopUpRotation | undefined>();
const selectedWebchargeState = ref<WebChargeStatus | undefined>()
const cardNumber = ref<string | undefined>();
const nextChargingDate = ref<string | undefined>();
const rotationEnd = ref<string | undefined>();


const rotations = computed(() => [
  {text: t('rotation_none'), state: TopUpRotation.None},
  {text: t('rotation_once'), state: TopUpRotation.Once},
  {text: t('rotation_monthly'), state: TopUpRotation.Monthly},
  {text: t('rotation_quarterly'), state: TopUpRotation.Quarterly},
  {text: t('rotation_yearly'), state: TopUpRotation.Yearly},
  {text: t('rotation_gratification'), state: TopUpRotation.Gratification},
]);

const webchargeState = computed(() => [
  {text: t('webcharge_state_success'), state: WebChargeStatus.Success },
  {text: t('webcharge_state_max_charge_limit'), state: WebChargeStatus.MaxChargeLimitError },
  {text: t('webcharge_state_max_card_limit'), state: WebChargeStatus.MaxCardLimitError },
  {text: t('webcharge_state_configuration_error'), state: WebChargeStatus.ConfigurationError },
  {text: t('webcharge_state_system_error'), state: WebChargeStatus.SystemError },
]);

const onHandleChange = () => {
  emits('onHandleSearchFilterChange', {
    rotation: unref(selectedRotation),
    cardNumber: unref(cardNumber),
    nextChargingDate: unref(nextChargingDate),
    rotationEnd: unref(rotationEnd),
    webchargeState: unref(selectedWebchargeState),
  });
};

const onHandleClearWebchargeState = () => {
  selectedWebchargeState.value = undefined;
};

const onHandleClearRotation = () => {
  selectedRotation.value = undefined;
};

const onHandleClearCardNumber = () => {
  cardNumber.value = undefined;
};

watch(() => cardNumber.value, debounce(() => {
  if (isEmpty(cardNumber.value)) cardNumber.value = undefined;

  if (cardNumber.value === undefined || isWholeNumber(cardNumber.value)) {
    onHandleChange()
  }
}));

const resetFilters = () => {
  selectedRotation.value = undefined;
  selectedWebchargeState.value = undefined;
  cardNumber.value = undefined;
  nextChargingDate.value = undefined;
  rotationEnd.value = undefined;
}

watch([nextChargingDate, rotationEnd, selectedRotation, selectedWebchargeState], () => {
  onHandleChange();
})

expose({
  resetFilters
})


return { __sfc: true,t, emits, selectedRotation, selectedWebchargeState, cardNumber, nextChargingDate, rotationEnd, rotations, webchargeState, onHandleChange, onHandleClearWebchargeState, onHandleClearRotation, onHandleClearCardNumber, resetFilters, DateInput }
}

})